<template>
    <div>
		<b-form-select v-model="selected" class="mb-1">
			<b-form-select-option v-for="item in baseCategoriesImages" :key="item.value" :value="item.value">
				{{item.name}}
			</b-form-select-option>
			<!-- <b-form-select-option-group label="Популярные теги">
				<b-form-select-option v-for="tag in tagsImages" :value="tag.value" :key="tag.value">
					{{tag.value}}
				</b-form-select-option>
			</b-form-select-option-group> -->
			<b-form-select-option-group v-for="optionGroup in tagsImages" :key="optionGroup.name" :label="optionGroup.name">
				<b-form-select-option v-for="tag in optionGroup.list" :value="tag.value" :key="tag.value">
					{{tag.value}}
				</b-form-select-option>
			</b-form-select-option-group>
		</b-form-select>
		<p v-if="images==0">Вы еще ничего не добавили</p>
        <div class="my-images">
            <img
                v-for="img in activeImages"
                :key="img"
                :src="img"
                alt=""
                class="available-texture texture-image"
                @click="drawSelectedImage(img)"
            />
        </div>
        <paginate
			v-if="pageCount>1"
			v-model="currentPage"
            :pageCount="pageCount"
            :clickHandler="paginationHandler"
            :prevText="'«'"
            :nextText="'»'"
            :containerClass="'pagination b-pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :next-class="'page-item'"
            :prev-class="'page-item'"
            :next-link-class="'page-link'"
            :prev-link-class="'page-link'"
        >
        </paginate>
	</div>
</template>

<script>
import { fabric } from "fabric";
import { fabricGif } from "@/utils/fabricGif";

export default {
    props:[
        'canvas',
		'isTextureBrush',
		'selectedType'
    ],
    data(){
        return{
			selected: "popular",
            image:null,
			currentPage: 1,
			imagesPerScreen: 10,
			library: [],
			// library:[
				// 	{
				// 		name:"Популярное",
				// 		value:"popular",
				// 		images:[
				// 			require("@/assets/popular/aron-visuals-bZZp1PmHI0E-unsplash.jpg"),
				// 			require("@/assets/popular/hao-wang-pVq6YhmDPtk-unsplash.jpg"),
				// 			require("@/assets/popular/jj-ying-7JX0-bfiuxQ-unsplash.jpg"),
				// 			require("@/assets/popular/lucas-benjamin-wQLAGv4_OYs-unsplash.jpg"),
				// 			require("@/assets/popular/pawel-czerwinski-Lki74Jj7H-U-unsplash.jpg"),
				// 			require("@/assets/popular/compass.svg"),
				// 			require("@/assets/popular/birds.png"),
				// 			require("@/assets/popular/honey_im_subtle.png"),
				// 			require("@/assets/popular/logo.png"),
				// 			require("@/assets/popular/fb.svg"),
				// 			require("@/assets/popular/table.jpg"),
				// 			require("@/assets/popular/nature.jpg"),
				// 			require("@/assets/popular/texture.jpg"),
				// 		]
				// 	},
				// 	{
				// 		name:"Гифки",
				// 		value:"gifs",
				// 		images:[
				// 			require("@/assets/gifs/fsdf342.gif"),
				// 			require("@/assets/gifs/123124.gif"),
				// 			require("@/assets/gifs/asdasd.gif"),
				// 			require("@/assets/gifs/cat.gif"),
				// 			require("@/assets/gifs/test.gif"),
				// 		]
				// 	},
				// 	{
				// 		name:"Ваш импорт",
				// 		value:"import",
				// 		images:[]
				// 	},
				// 	{
				// 		name:"Популярные теги",
				// 		value:"tags",
				// 		list:[
				// 			{
				// 				value:"rose",
				// 				images:[
				// 					require("@/assets/rose/rose1.png"),
				// 					require("@/assets/rose/rose2.png"),
				// 				]
				// 			},
				// 			{
				// 				value:"funny",
				// 				images:[
				// 					require("@/assets/funny/fun1.gif"),
				// 				]
				// 			},
				// 			{
				// 				value:"angels",
				// 				images:[
				// 					require("@/assets/angels/334849_713fa.png"),
				// 					require("@/assets/angels/1328131_8d983.png"),
				// 				]
				// 			},
				// 			{
				// 				value:"love",
				// 				images:[
				// 					require("@/assets/love/love1.gif"),
				// 					require("@/assets/love/love2.gif"),
				// 					require("@/assets/love/love3.png"),
				// 				]
				// 			},
				// 			{
				// 				value:"frames",
				// 				images:[
				// 					require("@/assets/frames/frame1.png"),
				// 					require("@/assets/frames/frame2.png"),
				// 					require("@/assets/frames/frame3.png"),
				// 					require("@/assets/frames/frame4.png"),
				// 					require("@/assets/frames/frame5.png"),
				// 					require("@/assets/frames/frame6.png"),
				// 					require("@/assets/frames/frame7.png"),
				// 				]
				// 			},
				// 			{
				// 				value:"nature",
				// 				images:[
				// 					require("@/assets/nature/nature (1).jpg"),
				// 					require("@/assets/nature/nature (2).jpg"),
				// 					require("@/assets/nature/nature (3).jpg"),
				// 					require("@/assets/nature/nature (4).jpg"),
				// 					require("@/assets/nature/nature (5).jpg"),
				// 					require("@/assets/nature/nature (6).jpg"),
				// 					require("@/assets/nature/nature (7).jpg"),
				// 					require("@/assets/nature/nature (8).jpg"),
				// 					require("@/assets/nature/nature (9).jpg"),
				// 					require("@/assets/nature/nature (10).jpg"),
				// 					require("@/assets/nature/nature (11).jpg"),
				// 					require("@/assets/nature/nature (12).jpg"),
				// 					require("@/assets/nature/nature (13).jpg"),
				// 					require("@/assets/nature/nature (14).jpg"),
				// 					require("@/assets/nature/nature (15).jpg"),
				// 					require("@/assets/nature/nature (16).jpg"),
				// 					require("@/assets/nature/nature (17).jpg"),
				// 					require("@/assets/nature/nature (18).jpg"),
				// 					require("@/assets/nature/nature (19).jpg"),
				// 					require("@/assets/nature/nature (20).jpg"),
				// 					require("@/assets/nature/nature (21).jpg"),
				// 				]
				// 			}
				// 		]
				// 	},
				// ]
		}
	},
	watch:{
		selected:function(){
			this.currentPage = 1;
		}
	},
	created(){
			// let jsonLibrary = JSON.stringify(this.library, null, 2);
			// console.log('jsonLibrary :', jsonLibrary);
			// setTimeout(() => {
			// 	let url = 'jsonData.json';
			// 	fetch(url).then(response =>response.json()).then(response => {
			// 				this.library = response;
			// 		});
				
			// }, 5000);
			let url = 'jsonData.json';
			fetch(url).then(response =>response.json()).then(response => {
					this.library = response;
				});
			

	},
	computed:{
		
		isCategoryFromTag(){
			// return this.library.find(item=>item.value == "tags").list.filter(item=>item.value === this.selected).length
			let subCatListsArr = [];
			let selected = this.selected;
			this.library.filter(item=>item.value == "tags").forEach(item=>{
					item.list.forEach((subCat =>{
						if(subCat.value === selected){
							subCatListsArr.push(subCat);
						}
					}
					))
			});
			return subCatListsArr.length;
			
		},
		baseCategoriesImages(){
			let result = this.library.filter(item=>item.value !== "tags")
			console.log('result', result)
			return result
		},
		tagsImages(){
			// return this.library.find(item=>item.value == "tags").list
			return this.library.filter(item=>item.value == "tags")
		},
		images(){
			let result;
			console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', this.isCategoryFromTag);
			let library = this.library;
			let selected = this.selected;
			function findCategoryFromTags () {
				let subCatListsArr = [];
				library.filter(item=>item.value == "tags").forEach(item=>item.list.forEach(subCat => subCatListsArr.push(subCat)));
				return subCatListsArr.find(item=>item.value === selected).images;
			}
			this.isCategoryFromTag
				// ? result = this.library.find(item=>item.value === "tags").list.find(item=>item.value === this.selected).images
				? result = findCategoryFromTags()
				: result = this.library.find(item=>item.value === this.selected).images
			console.log(result)
			return result
		},
		pageCount() {
			const pages = Math.ceil(this.images.length / this.imagesPerScreen)
			console.log(pages)
			return pages;
		},
		activeImages() {
			let from =
				this.imagesPerScreen * this.currentPage - this.imagesPerScreen;
			let to = this.imagesPerScreen * this.currentPage;
			return this.images.slice(from, to);
		},
    },
    methods:{
		
        paginationHandler(pageNum) {
			this.currentPage = pageNum;
			console.log(this.currentPage);
		},
        methodDraw(img) {
			const canvas = this.canvas;
			console.log("methodDraw = ",img)
			img.set({
				left: 100,
				top: 100,
			});
			img.scaleToWidth(200);
			this.canvas.add(img).setActiveObject(img);
            this.$emit('enableEditingMode');
			fabric.util.requestAnimFrame(function render() {
				canvas.renderAll();
				fabric.util.requestAnimFrame(render);
			});
		},
		async drawSelectedImage(image) {

			if(this.selectedType === "text"){
				console.log("drawSelectedImage text")

				let target = this.canvas.getActiveObject();
				target.set("animatedColor",false);
				fabric.util.loadImage(image, (img)=> {
					target.set('fill', new fabric.Pattern({
						source: img,
						repeat: "repeat"
					}));
					
					this.canvas.renderAll();
				});
				return
			}

			if(this.isTextureBrush){
				this.$emit('setCurrentImage',image);
			}else{
				try {
					this.methodDraw(await fabricGif(image, 200, 200));
				} catch (error) {
					this.drawImage(image);
				}
			}
		},
		async drawGif(image) {
			this.methodDraw(await fabricGif(image, 200, 200));
		},
		drawImage(image) {
			fabric.Image.fromURL(image, (img) => {
				this.methodDraw(img);
			});
		},
        drawReceivedImage(file) {
            console.log(file)
			const image = URL.createObjectURL(file);
            this.image = image
            console.log(this.image)

			const extension = file.name.split(".").pop();

			console.log("extension = ", extension);

			if (extension === "gif") {
				this.drawGif(image);
			} else {
				this.drawImage(image);
			}

			this.library.forEach(item => {
				if(item.value === "import"){
					item.images.unshift(image)
				}
			});

			this.selected = "import"
		},
    }
}
</script>

<style>

</style>